<template>
  <div>
    <div class="header">
      <div>
        <img
          @click="goToDashboard()"
          class="logo pointer"
          src="/slicingPie-logo.png"
        />
      </div>
      <div class="items">
        <!-- Home -->
        <div @click="goToDashboard()" class="item me-4">
          <v-icon>mdi-home-outline</v-icon> داشبورد
        </div>
        <!-- Other -->
        <div class="item me-4">
          <a
            href="https://slicingpie.ir/"
            target="_blank"
            style="text-decoration: none; color: #555"
          >
            <v-icon>mdi-help-circle-outline</v-icon> راهنما</a
          >
        </div>
        <v-menu
          v-for="(item, index) in menu"
          :key="index"
          open-on-hover
          bottom
          offset-y
        >
          <template v-slot:activator="{ on, attrs }">
            <div class="item" v-bind="attrs" v-on="on">
              <v-icon>{{ item.icon }}</v-icon>
              {{ item.name }}
              <v-icon class="chevron-icon">mdi-chevron-down</v-icon>
            </div>
          </template>
          <v-list>
            <v-list-item
              v-for="(item2, index) in item.children"
              :key="index"
              @click="
                item2.name != 'خروج' ? $router.push(item2.link) : logout()
              "
            >
              <v-list-item-title v-if="item2.name != 'خروج'">
                <v-icon>{{ item2.icon }}</v-icon>
                {{ item2.name }}
              </v-list-item-title>
              <v-list-item-title v-else>
                <v-icon>{{ item2.icon }}</v-icon>
                {{ item2.name }}
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>
      <div class="d-sm-none d-flex">
        <div class="d-md-none d-block pe-4 pt-5 pointer" @click="drawer = true">
          <v-icon>mdi-menu</v-icon>
        </div>
      </div>
    </div>
    <v-navigation-drawer
      v-model="drawer"
      absolute
      temporary
      left
      style="position: fixed"
    >
      <nav dense dir="ltr" class="mt-3">
        <v-list rounded class="white">
          <v-list-item @click="goToDashboard()">
            <v-list-item-icon>
              <v-icon>mdi-home-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title> داشبورد </v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item>
            <a
              href="https://slicingpie.ir/"
              target="_blank"
              style="text-decoration: none; color: #000000de"
            >
              <v-icon class="ms-3 fs-xlarge">mdi-help-circle-outline</v-icon>
              راهنما</a
            >
          </v-list-item>

          <v-list-group
            v-for="(item, index) in menu"
            :key="index"
            :value="false"
            :prepend-icon="item.icon"
          >
            <template v-slot:activator>
              <v-list-item-title>{{ item.name }}</v-list-item-title>
            </template>
            <v-list-item
              v-for="(item2, index) in item.children"
              :key="index"
              @click="
                item2.name != 'خروج' ? $router.push(item2.link) : logout()
              "
              class="me-4"
            >
              <template>
                <v-list-item-icon>
                  <v-icon>{{ item2.icon }}</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>{{ item2.name }}</v-list-item-title>
                </v-list-item-content>
              </template>
            </v-list-item>
          </v-list-group>
        </v-list>
      </nav>
    </v-navigation-drawer>
  </div>
</template>

<script>
const MVPInfo = () => import("@/components/MVPInfo");
import { mapGetters, mapMutations } from "vuex";
import { SpringSpinner } from "epic-spinners";
export default {
  components: { MVPInfo, SpringSpinner },
  data() {
    return {
      role: "",
      busy: false,
      summaryList: [],
      infoDialog: false,
      title: "",
      drawer: false,
      selectedId: "",
    };
  },
  methods: {
    ...mapMutations(["setUserName"]),
    logout() {
      window.localStorage.clear();
      window.location.replace("/");
    },
    openDialog(name) {
      this.title = name;
      this.infoDialog = true;
    },
    goToDashboard() {
      if (this.role == "admin") {
        this.$router.push("/adminDashboard");
      } else {
        this.$router.push("/dashboard");
      }
    },
  },
  computed: {
    ...mapGetters(["userName"]),
    menu() {
      return [
        //{
        //  name: "راهنما",
        //  icon: "mdi-help-circle-outline",
        //  children: [
        //    {
        //      name: "راهنمای کاربر",
        //      icon: "mdi-book-open-variant",
        //      link: "",
        //    },
        //    {
        //      name: "تماس با پشتیبانی",
        //      icon: "mdi-forum-outline",
        //      link: "",
        //    },
        //    {
        //      name: "دفترچه راهنما",
        //      icon: "mdi-book-open-outline",
        //      link: "",
        //    },
        //  ],
        //},
        {
          name: this.userName ? this.userName : "بدون نام",
          icon: "mdi-account-outline",
          children: [
            {
              name: "خروج",
              icon: "mdi-power",
              link: "",
            },
          ],
        },
      ];
    },
  },
  watch: {},
  mounted() {
    this.role = localStorage.getItem("role");
    this.setUserName(localStorage.getItem("name"));
  },
};
</script>

<style lang="scss">
.gravatar {
  width: 55px;
  height: 55px;
}
.icon-relative {
  position: relative;
}
.chip {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  min-width: 22px;
  height: 22px;
  border-radius: 50px;
  background-color: #4caf50;
}
.chip-absolute {
  position: absolute;
  top: 10px;
  left: 17px;
}
.nav-chip-absolute {
  position: absolute;
  top: -10px;
  left: 8px;
}
.header {
  background-color: #fff;
  height: 65px;
  width: 100%;
  border-bottom: 1px solid #ccc;
  padding: 0 110px;
  display: flex;
  justify-content: space-between;

  .logo {
    width: 65px;
    margin-top: 2px;
  }
  .items {
    display: flex;
    align-items: center;
    .item {
      margin-right: 28px;
      font-size: 0.9rem;
      color: #555;
      height: 65px;
      display: flex;
      align-items: center;
      cursor: pointer;
      .v-icon {
        font-size: 1.6rem;
        color: #555;
        margin-left: 7px;
      }
      .chevron-icon {
        font-size: 1.2rem;
        margin-right: 4px;
      }
    }
  }
  @media only screen and (max-width: 599px) {
    padding: 0 15px;
    .items {
      display: none;
    }
  }
}

.v-list-item__icon {
  margin-left: 0 !important;
  margin-right: 15px !important;
}
.v-list-item__title {
  font-size: 14px !important;
}
.text-color {
  color: #bf0000;
}
// .v-expansion-panel::before {
//   border-radius: 0;
//   -webkit-transition: none;
//   transition: none;
//   box-shadow: none;
//   -webkit-box-shadow: none;
//   border: 1px solid #000;
// }
// // .v-expansion-panel-content__wrap {
// //   border-bottom: 1px solid #ccc;
// // }
// .v-expansion-panels .v-expansion-panel .v-expansion-panel-hedear {
//   border-top: 1px solid #ccc;
// }
</style>
